(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donkey-logo-scroller"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-section-type="donkey-logo-scroller"] .scroller').forEach(function (scroller) {
      scroller.setAttribute('data-animated', 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-banner"] && !Shopify.designMode) return;
  try {
    
  /* Locks the banner height in px so it can't track the mobile address bar.
     Firefox iOS resizes its WebView when its toolbar collapses and resolves
     lvh/svh/dvh against the live height (unlike Safari/Chrome iOS), so no CSS
     viewport unit stays fixed there. We measure 100lvh once and expose it as a
     px value (--vb-lvh) consumed by .video-banner__frame--* in theme.css.
     Re-measured only on orientation change — never on resize/scroll — so the
     toolbar hiding cannot change the locked value. */
  (function () {
    function lockViewportUnit() {
      var probe = document.createElement('div');
      probe.style.cssText =
        'position:absolute;top:0;left:0;width:0;height:100lvh;visibility:hidden;pointer-events:none;';
      document.body.appendChild(probe);
      var measured = probe.getBoundingClientRect().height;
      document.body.removeChild(probe);
      // Fall back to innerHeight if lvh is unsupported (old in-app webviews).
      if (!measured) measured = window.innerHeight;
      if (measured > 0) {
        document.documentElement.style.setProperty('--vb-lvh', (measured / 100) + 'px');
      }
    }
    lockViewportUnit();
    window.addEventListener('orientationchange', function () {
      // Let the viewport settle after rotation before re-measuring.
      setTimeout(lockViewportUnit, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
